import { Observable } from 'rxjs';
import { RestService } from '../rest-service';

export interface ReportBaseService<T, ReportSearchRequest> extends RestService<T, ReportSearchRequest> {
	saveNew(report: T): Observable<T>;
	update(report: T): Observable<T>;
}
